<template>
  <main class="home">
    <section class="intro">
      <div class="wrapper">
        <header>
          <svg class="logo" viewBox="0 0 542 788" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M195.457 342.954C195.457 453.633 165.591 534.446 130.455 606.476" stroke="#FFFBEC" stroke-width="23.6364"/>
            <path d="M342.995 343.745C342.995 453.76 372.681 534.088 407.606 605.684" stroke="#FFFBEC" stroke-width="23.6364"/>
            <rect x="145.015" y="274.944" width="251.97" height="60.4777" rx="30.2388" stroke="#FFFBEC" stroke-width="25.6061"/>
            <path d="M471.277 670.147V670.147C471.277 631.336 439.815 599.874 401.004 599.874H140.996C102.185 599.874 70.7234 631.336 70.7234 670.147V670.147" stroke="#FFFBEC" stroke-width="25.6061"/>
            <path d="M528.746 761.878V773.785C528.746 773.958 528.746 774.123 528.746 774.28C528.588 774.281 528.423 774.281 528.25 774.281H13.7496C13.5767 774.281 13.4118 774.281 13.2542 774.28C13.2541 774.123 13.2541 773.958 13.2541 773.785C13.2541 747.245 13.3755 736.619 15.7359 728.258C21.97 706.174 39.229 688.915 61.3124 682.681C69.674 680.321 80.2998 680.199 106.84 680.199H381.692H447.067C462.134 680.199 468.183 680.239 473.042 681.005C501.31 685.464 523.481 707.636 527.94 735.903C528.706 740.762 528.746 746.811 528.746 761.878Z" stroke="#FFFBEC" stroke-width="25.6061" stroke-linecap="round"/>
            <path d="M138.514 199.954L148.023 206.972L148.023 206.972L138.514 199.954ZM276.442 13.0638L285.951 20.0816L285.951 20.0816L276.442 13.0638ZM279.612 13.0638L289.121 6.04602L289.121 6.04602L279.612 13.0638ZM417.54 199.954L408.031 206.972L408.031 206.972L417.54 199.954ZM339.93 263.221C335.315 267.836 335.315 275.319 339.93 279.935C344.545 284.55 352.028 284.55 356.644 279.935L339.93 263.221ZM148.023 206.972L285.951 20.0816L266.933 6.04601L129.005 192.936L148.023 206.972ZM270.103 20.0816L408.031 206.972L427.049 192.936L289.121 6.04602L270.103 20.0816ZM408.991 194.16L339.93 263.221L356.644 279.935L425.705 210.873L408.991 194.16ZM216.124 263.221L147.063 194.16L130.349 210.873L199.41 279.935L216.124 263.221ZM408.031 206.972C405.138 203.052 405.546 197.605 408.991 194.16L425.705 210.873C430.528 206.05 431.1 198.425 427.049 192.936L408.031 206.972ZM285.951 20.0816C282.015 25.4154 274.039 25.4154 270.103 20.0816L289.121 6.04602C283.61 -1.4213 272.444 -1.4213 266.933 6.04603L285.951 20.0816ZM129.005 192.936C124.954 198.425 125.526 206.05 130.349 210.873L147.063 194.16C150.508 197.605 150.916 203.052 148.023 206.972L129.005 192.936Z" fill="#FFFBEC"/>
            <line x1="277.581" y1="13.7867" x2="277.581" y2="185.548" stroke="#FFFBEC" stroke-width="23.6364"/>
            <circle cx="277.413" cy="172.213" r="21.4465" stroke="#FFFBEC" stroke-width="23.6364"/>
          </svg>

          <div>
            <h1>Chess Notepad</h1>
            <div>Chess Notation and Clock</div>
          </div>
        </header>

        <p>Easily save over the board chess games while mastering algebraic notation without&nbsp;trying.</p>

        <h2>
          <button class="button center" id="explainer-button">How Chess Notepad Works</button>
        </h2>
      </div>
      <section id="explainer" class="chess-notepad__full-instructions" hidden>
        <div class="wrapper">
          <button class="ex-button">
            <span class="visually-hidden">close</span>
            <svg viewBox="0 0 18 18">
              <path d="M13.2095 4.89523L4.99998 13.1048" />
              <path d="M13.2095 13.1048L4.99998 4.89525" />
            </svg>
          </button>
          <h3>How to Note Moves</h3>
          
          <p>This app makes chess notation easy while training you how to do it on your own. Each player will get a series of notation buttons once they've made their move and stopped their clock.</p>

          <div class="callout">
            <svg style="width: 20px; height: 50px; margin-right: 5px;" width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.11976 7.04805L1.06618 13.0508L1.06618 1.0453L9.11976 7.04805Z" stroke="#FFFBEC" stroke-width="2"/>
            </svg>
            <p>Watch this <a href="https://chessnotepad.com/learn-chess-notation-in-3-minutes-video/">3-minute video</a> explaining chess notation.</p>
          </div>

          <h4>Step 1: Note the piece</h4>
          <p>First, note the kind of piece you moved by tapping the corresponding letter.</p>

          <ul>
            <li><strong class="monospace">K</strong> = King</li>
            <li><strong class="monospace">Q</strong> = Queen</li>
            <li><strong class="monospace">B</strong> = Bishop</li>
            <li><strong class="monospace">N</strong> = Knight</li>
            <li><strong class="monospace">R</strong> = Rook</li>
            <li><strong class="monospace">&nbsp;</strong> = Pawn</li>
          </ul>

          <p>Knights are known as N since K is reserved for the king. Pawns don't even get a letter, the blank button is for them.</p>

          <div class="callout callout--castling">
            When you castle, you only need to tap one button. There's different buttons for kingside and queenside castling.
          </div>

          <h4>Steps 2 & 3: Note the destination</h4>
          <p>The board is composed of files (columns) and ranks (rows). They are both named starting from white's perspective. The file with white's leftmost rook is "a", the next one is "b" and so on until "h". The rank where white's major pieces start is "1", white's pawns start on "2" and so on. This arrangement means that black's leftmost rook starts on the h file and the 8th rank. In this system, each square has a name such as f4 or b8.</p>

          <div class="chess-board monospace">
            <div>
              <div class="ranks">
                <div>8</div>
                <div>7</div>
                <div>6</div>
                <div>5</div>
                <div>4</div>
                <div>3</div>
                <div>2</div>
                <div>1</div>
              </div>
              
              <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="80" height="80" fill="#FFFBEC"/>
                <rect x="160" width="80" height="80" fill="#FFFBEC"/>
                <rect x="320" width="80" height="80" fill="#FFFBEC"/>
                <rect x="480" width="80" height="80" fill="#FFFBEC"/>
                <rect y="160" width="80" height="80" fill="#FFFBEC"/>
                <rect x="160" y="160" width="80" height="80" fill="#FFFBEC"/>
                <rect x="320" y="160" width="80" height="80" fill="#FFFBEC"/>
                <rect x="480" y="160" width="80" height="80" fill="#FFFBEC"/>
                <rect y="320" width="80" height="80" fill="#FFFBEC"/>
                <rect x="160" y="320" width="80" height="80" fill="#FFFBEC"/>
                <rect x="320" y="320" width="80" height="80" fill="#FFFBEC"/>
                <rect x="480" y="320" width="80" height="80" fill="#FFFBEC"/>
                <rect y="480" width="80" height="80" fill="#FFFBEC"/>
                <rect x="160" y="480" width="80" height="80" fill="#FFFBEC"/>
                <rect x="320" y="480" width="80" height="80" fill="#FFFBEC"/>
                <rect x="480" y="480" width="80" height="80" fill="#FFFBEC"/>
                <rect x="80" y="80" width="80" height="80" fill="#FFFBEC"/>
                <rect x="240" y="80" width="80" height="80" fill="#FFFBEC"/>
                <rect x="400" y="80" width="80" height="80" fill="#FFFBEC"/>
                <rect x="560" y="80" width="80" height="80" fill="#FFFBEC"/>
                <rect x="80" y="240" width="80" height="80" fill="#FFFBEC"/>
                <rect x="240" y="240" width="80" height="80" fill="#FFFBEC"/>
                <rect x="400" y="240" width="80" height="80" fill="#FFFBEC"/>
                <rect x="560" y="240" width="80" height="80" fill="#FFFBEC"/>
                <rect x="80" y="400" width="80" height="80" fill="#FFFBEC"/>
                <rect x="240" y="400" width="80" height="80" fill="#FFFBEC"/>
                <rect x="400" y="400" width="80" height="80" fill="#FFFBEC"/>
                <rect x="560" y="400" width="80" height="80" fill="#FFFBEC"/>
                <rect x="80" y="560" width="80" height="80" fill="#FFFBEC"/>
                <rect x="240" y="560" width="80" height="80" fill="#FFFBEC"/>
                <rect x="400" y="560" width="80" height="80" fill="#FFFBEC"/>
                <rect x="560" y="560" width="80" height="80" fill="#FFFBEC"/>
              </svg>
            </div>

            <div class="files">
              <div>a</div>
              <div>b</div>
              <div>c</div>
              <div>d</div>
              <div>e</div>
              <div>f</div>
              <div>g</div>
              <div>h</div>
            </div>
          </div>

          <p>In most cases, noting the piece and the destination is all you need to do. However, some circumstances require more information.</p>

          <h4>Special Circumstances</h4>

          <h5>Disambiguating Pieces</h5>
          <p>Depending on how the board is arranged, the same type of piece may legally be able to move to the same square. For example, if both white rooks are on the first rank with no pieces between them, either rook may move anywhere between them. In this instance you would need to specify the square the rook came from as well as its destination square.</p>

          <p>You only need to provide either the file or rank of the starting square since that is almost always enough to disambiguate. However sometimes you need to specify both rank and file and it never hurts to specify both. You can do this by pressing "Note Starting Position" after you've indicated which piece you've moved.</p>

          <div class="callout callout--pawn">
            When a pawn captures, you must always note its starting position, even if it couldn't be confused with another pawn. This is just the way things are.
          </div>

          <h5>Pawn Promotion</h5>
          <p>When a pawn reaches the other end of the board it will get promoted. In this case, you'll be presented with options to indicate which piece the pawn was promoted to (usually a queen).</p>
        
          <h3>How the Clock Works</h3>
          <p>Clocks are set as "N minutes | N increment seconds". The increment is added after each move.</p>
          <p>The screen is divided in half. Black taps his or her clock to start the other clock and the game.</p>
        </div>
      </section>
    </section>

    <section class="clocks wrapper">
      <h2>Clocks</h2>
      <ul id="clock-presets" class="clock-buttons">
        <li>
          <a class="button" href="game/#5400+30">
            <span class="base-time">90 min</span>
            <span class="bonus-time">30 sec</span>
          </a>
        </li>
        <li>
          <a class="button" href="game/#1800">
            <span class="base-time">30 min</span>
          </a>
        </li>
        <li>
          <a class="button" href="game/#900+10">
            <span class="base-time">15 min</span>
            <span class="bonus-time">10 sec</span>
          </a>
        </li>
        <li>
          <a class="button" href="game/#600+5">
            <span class="base-time">10 min</span>
            <span class="bonus-time">5 sec</span>
          </a>
        </li>
        <li>
          <a class="button" href="game/#600">
            <span class="base-time">10 min</span>
          </a>
        </li>
        <li>
          <a class="button" href="game/#300+5">
            <span class="base-time">5 min</span>
            <span class="bonus-time">5 sec</span>
          </a>
        </li>
       
      </ul>
      <button class="button custom-time" hidden>Custom Time</button>
    </section>

    <section class="text-center">
      <a href="https://www.cognitoforms.com/Tyler3/ChessNotepadFeedback" target="_blank">Give feedback</a>
    </section>

    <section class="ad-section">
      <div class="wrapper wrapper--ad">
        <a class="ad" target="_blank" href="https://amzn.to/4dtAzAr">
          <span>Play chess on a beautiful board with ornate algebraic coordinate labels.</span>
        </a>
      </div>
    </section>
    <footer class="footer wrapper">
      <div><small>&copy; Chess Notepad 2024</small></div>
      <div><small>Chess Notepad receives commissions on Amazon and Chess.com purchases.</small></div>
    </footer>
  </main>
</template>

<script>
  export default {
    name: 'ChessInfo',
    props: {
      gameStarted: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      // Copied from static page
      const explainerButton = document.getElementById('explainer-button');
      const explainer = document.getElementById('explainer');
      const ex = document.querySelector('#explainer .ex-button');
      explainer.classList.add('wrapper');
      document.body.append(explainer);

      ex.addEventListener('click', () => {
        explainer.setAttribute('hidden', true);
      });

      explainerButton.addEventListener('click', () => {
        explainer.removeAttribute('hidden');
      });
      // -- //

      document.querySelectorAll('#clock-presets a').forEach(a => {
        a.addEventListener('click', this.handleClick);
      });
    },
    methods: {
      handleClick(e) {
        // TODO: Make this not reload SPA
        e.preventDefault();
        const buttonEl = e.target.classList.contains('button') ? e.target : e.target.parentElement;
        const time = buttonEl.getAttribute('href').replace('game/#', '');
        if (this.gameStarted) {
          if (window.confirm("Do you want to reset your current game?"))
            window.location.hash = time;
          else
            return;
        } else
          window.location.hash = time;
          
        this.$emit('newGame', time);
      }
    }
  }
</script>